module.exports = __webpack_public_path__ + "img/share-the-sun.b8059614.svg";